import Swagger from 'swagger-client';
import { handleError, error, receive, request } from '../../lib/Utils';
let api = new Swagger('/api/docs');


const requestLogout = () => {
  return { type: LOGOUT.REQUEST };
};

const  logoutError = (error) => {
  return { type: LOGOUT.ERROR, error };
};

function logoutSuccess() {
  return { type: LOGOUT.SUCCESS };
}


export const LOGOUT = {
  REQUEST: "LOGOUT_REQUEST",
  SUCCESS: "LOGOUT_SUCCESS",
  FAILURE: "LOGOUT_FAILURE"
};

export const logout = () => {

  localStorage.removeItem('user_status');

  return (dispatch) => {
    dispatch(requestLogout());
    api.then(client => {
      client.apis.Users.logout()
      .then((payload) => {
        if (payload.ok) {
          dispatch(logoutSuccess());
        } else {
          payload.json(json => {
            dispatch(logoutError({
              statusCode: payload.status,
              message: json.message
            }));
          });
        }
      }).catch((error) => {
        dispatch(logoutError({ message: error.message }));
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/containers/Authentication/LogoutActions.js